import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
// import config from '@/config'
// const title = config.title

export default new Router({
	mode: 'history',
	routes: [{
		path: '/',
		component: resolve => require(['@/view/PageView'], resolve),
		children: [{
				path: '/',
				redirect: '/index'
			}, {
				path: '/index',
				name: 'index',
				component: resolve => require(['@/view/index'], resolve),
				meta: {
					title: '首页',

				}
			},
			{
				path: '/operate',
				name: 'operate',
				component: resolve => require(['@/view/operate'], resolve),
				meta: {
					title: '产品中心',
				},
			},
			{
				path: '/case_center',
				name: 'case_center',
				component: resolve => require(['@/view/case_center'], resolve),
				meta: {
					title: '案例中心',

				}
			},
			{
				path: '/casedetails',
				name: 'casedetails',
				component: resolve => require(['@/view/casedetails'], resolve),
				meta: {
					title: '案例详情',

				}
			},
			{
				path: '/business',
				name: 'business',
				component: resolve => require(['@/view/business'], resolve),
				meta: {
					title: '业务合作',
				},
			},
			{
				path: '/news',
				name: 'news',
				component: resolve => require(['@/view/news'], resolve),
				meta: {
					title: '新闻资讯',

				}
			},
			{
				path: '/newdetails',
				name: 'newdetails',
				component: resolve => require(['@/view/newdetails'], resolve),
				meta: {
					title: '新闻详情',

				}
			},
			{
				path: '/aboutus',
				name: 'aboutus',
				component: resolve => require(['@/view/aboutus'], resolve),
				meta: {
					title: '关于我们',

				}
			}
		]
	}]
})


// WEBPACK FOOTER //
// ./src/router/index.js